export const ClaimStatusColor = {
    COMPLETED: '#79c91c',
    INPROGRESS: '#f29b02',
    PENDING: '#778898',
    DRAFT: '#d3d3d3',
    DENIED: '#23a4ed'
}